// extracted by mini-css-extract-plugin
module.exports = {"main":"sk-CardBody_main__MOweR"};